import { useState } from "react";
import { useScrollReveal } from "@/hooks/useScrollReveal";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Textarea } from "@/components/ui/textarea";
import { Card, CardContent } from "@/components/ui/card";
import { Phone } from "lucide-react";

const ContactSection = () => {
  const ref = useScrollReveal();
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [service, setService] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Future: send to backend
    alert("הטופס נשלח בהצלחה! ניצור איתך קשר בהקדם.");
    setName("");
    setPhone("");
    setService("");
    setMessage("");
  };

  return (
    <section id="contact" className="py-20 bg-background" ref={ref}>
      <div className="container mx-auto px-4">
        <div className="max-w-2xl mx-auto">
          {/* Lead Form */}
          <div className="animate-on-scroll">
            <Card className="border-border shadow-lg">
              <CardContent className="p-8">
                <h2 className="text-2xl md:text-3xl font-bold text-foreground mb-2">
                  צרו <span className="text-primary">קשר</span>
                </h2>
                <p className="text-muted-foreground mb-6">השאירו פרטים ונחזור אליכם תוך שעות ספורות</p>

                <form onSubmit={handleSubmit} className="space-y-4">
                  <div>
                    <label htmlFor="name" className="block text-sm font-medium text-foreground mb-1">שם מלא</label>
                    <Input
                      id="name"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      placeholder="הזינו את שמכם"
                      required
                    />
                  </div>
                  <div>
                    <label htmlFor="phone" className="block text-sm font-medium text-foreground mb-1">טלפון</label>
                    <Input
                      id="phone"
                      type="tel"
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                      placeholder="054-572-5681"
                      required
                      dir="ltr"
                      className="text-right"
                    />
                  </div>
                  <div>
                    <label htmlFor="service" className="block text-sm font-medium text-foreground mb-1">סוג שירות</label>
                    <Select value={service} onValueChange={setService}>
                      <SelectTrigger id="service" aria-label="סוג שירות">
                        <SelectValue placeholder="בחרו שירות" />
                      </SelectTrigger>
                      <SelectContent>
                        <SelectItem value="leaks">איתור ותיקון נזילות</SelectItem>
                        <SelectItem value="construction">בנייה קלה</SelectItem>
                        <SelectItem value="gutters">מרזבים</SelectItem>
                        <SelectItem value="metal">פחחות</SelectItem>
                        <SelectItem value="ventilation">אוורור גגות</SelectItem>
                        <SelectItem value="other">אחר</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                  <div>
                    <label htmlFor="message" className="block text-sm font-medium text-foreground mb-1">הודעה (לא חובה)</label>
                    <Textarea
                      id="message"
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                      placeholder="ספרו לנו פרטים נוספים על הפנייה"
                      rows={4}
                      maxLength={1000}
                    />
                  </div>
                  <Button type="submit" className="w-full bg-primary text-primary-foreground hover:bg-gold-light font-bold text-lg py-6">
                    <Phone size={18} />
                    שלחו פנייה
                  </Button>
                </form>
              </CardContent>
            </Card>
          </div>

        </div>
      </div>
    </section>
  );
};

export default ContactSection;
